import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText, FDHeadlineText } from '@facet-wealth/design';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'sm' },
  }, {
    ordinal: 201,
  })
  .nameOverride(['subtitle'], {
    _component: () => FDBodyText,
  }, {
    ordinal: 201,
  });

export default metaOverrideSet;
